<template>
  <div class="wrapper">
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="detail">
      <Header />
      <div class="inner">
        <slick ref="slick" :class="{ 'slick-outer detail_slider': proposal.image_name.length}">
          <div v-for="image_name in proposal.image_name" :key="image_name.no"><img :src="image_name.path" alt="" class="slick-img"></div>
        </slick>
        <div class="detail_title">
          <div class="column_l">
            <h2 class="detail_name">{{proposal.name}}</h2>
            <p class="detail_client">{{proposal.client_name}}</p>
          </div>
          <div class="column_r">
            <p class="detail_renewal-date"><svg>
              <use xlink:href="/svg/sprite.svg#icon_renewal" /></svg>{{proposal.entdt|dateFormat}}</p>
            <p class="detail_heartbtn"><a href="javascript:void(0)" v-on:click="favoriteReg" class="btn02 cl_rd">
            <svg class="active" v-if="favorite"><use xlink:href="/svg/sprite.svg#icon_heart-solid"/></svg>
            <svg v-else><use xlink:href="/svg/sprite.svg#icon_heart" /></svg>
            </a></p>
            <p v-if="proposal.edit_flg" class="detail_upbtn"><a :href="'/up/'+proposal.pk+'/'" class="btn01 cl_pp"><svg><use xlink:href="/svg/sprite.svg#icon_pen"/></svg></a></p>
          </div>
        </div>
        <div class="detail_wrap">
          <div class="detail_contents">
            <ul class="tag_list">
              <li v-for="item in proposal.p_m_tag_pk" :key="item.pk">{{item.name}}</li>
              <li v-for="item in proposal.b_m_tag_pk" :key="item.pk">{{item.name}}</li>
              <li v-for="item in proposal.c_m_tag_pk" :key="item.pk">{{item.name}}</li>
            </ul>
            <div class="member_list">
              <h3><svg>
                <use xlink:href="/svg/sprite.svg#icon_member" /></svg>Member</h3>
              <ul>
                <li v-for="item in proposal.pe_m_tag_pk" :key="item.pk">{{item.name}}</li>
              </ul>
            </div>
            <div class="detail_text" v-html="proposal.description"></div>
          </div>
          <div class="detail_file" v-if="proposal.file_name.length">
            <ul class="file-list">
              <li>
              <li v-for="item in filterOnlyFile" :key="item.no">
                <div class="file-l">
                  <input type="checkbox" v-model="chk_files" v-bind:value="item.no" v-bind:id="item.no" class="check_type02">
                  <label v-bind:for="item.no" class="label_type02"><i class="fas" :class="fileIcon(item.ext)"></i>{{item.name}}</label>
                </div>
                <div class="file-r">
                  <span class="file-capacity">{{item.byte}}</span>
                  <p class="file-delete"><button v-on:click="fileDownload(item.no)" class="btn01 cl_bl"><svg>
                      <use xlink:href="/svg/sprite.svg#icon_download" /></svg>DL</button></p>
                </div>
              </li>
            </ul>
            <p class="file-btn"><button type="button" class="btn01 cl_bl" v-on:click="fileDownload()"><svg>
                <use xlink:href="/svg/sprite.svg#icon_download" /></svg>チェックしたファイルを全てダウンロード</button></p>
          </div>
        </div>
        <div class="btnbox"><a :href="referrer" class="linebtn_bold arrow_l">一覧へ戻る</a></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Mixin
  } from '../mixin'
  export default {
    name: 'Detail',
    mixins: [Mixin],
    data() {
      return {
        chk_files: [],
        referrer: "javascript:history.back()",
        favorite: false,
        //警告になるためここで宣言
        proposal: {
          image_name: [],
          file_name: []
        },
        slickOptions: {
          arrows: false
        }
      }
    },
    created() {
      //Loading Start
      var loader = this.loadingShow()
      var self = this
      let params = new URLSearchParams()
      params.append('c', 'proposal-2')
      params.append('pk', this.$route.params.pk)
      params.append('lo_pk', this.$cookies.get('lo_pk'))
      params.append('lo_sid', this.$cookies.get('lo_sid'))
      return this.axios.post(this.RequestURI, params, {
        headers: {
          "Cache-Control": "no-cache"
        }
      }).then((res) => {
        if (res.data.status == 'success') {
          const obj = res.data.values
          //console.log(JSON.stringify(obj))
          self.proposal = Object.assign(self.proposal, obj)
          self.favorite = res.data.favorite
          //添付取得
          for (var i = 0; obj.file_name.length > i; i++) {
            if (obj.file_name[i].ext.match(/jpg|jpeg|png|gif|bmp|svg/i)) {
              self.proposal.image_name.push({
                no: obj.file_name[i].no,
                path: '/upload/proposal/' + obj.pk + '/' + obj.file_name[i].no + '.' + obj.file_name[i].ext
              })
            }
          }
          //画像が無ければslick無効
          if (!self.proposal.image_name.length) this.$refs.slick.destroy()
          //一覧戻るリンク
          const r = new RegExp(location.hostname);
          if (!document.referrer.match(r)) self.referrer = '/'
          //説明の改行対応
          self.proposal.description = this.$options.filters.toBr(self.proposal.description)
          loader.hide()
        } else {
          this.$router.push("/login/")
        }
      }).catch((e) => {
        alert(e)
      })
    },
    watch: {
      'proposal.image_name': function() {
        //var self = this
        this.$refs.slick.destroy()
        this.$nextTick(() => {
          this.$refs.slick.create()
        })
      },
      deep: true
    },
    computed:{
      filterOnlyFile() {
        var self = this
        return self.proposal.file_name.filter(function(item) {
          return !item.ext.match(/jpg|jpeg|png|gif|bmp|svg/i)
        })
      }
    },
    methods: {
      favoriteReg() {
        var self = this
        let params = new URLSearchParams()
        params.append('c', 'favorite-ajax')
        params.append('pk', this.$route.params.pk)
        params.append('lo_pk', this.$cookies.get('lo_pk'))
        params.append('lo_sid', this.$cookies.get('lo_sid'))
        params.append('favorite', self.favorite)
        return this.axios.post(this.RequestURI, params, {
          headers: {
            "Cache-Control": "no-cache"
          }
        }).then((res) => {
          if (res.data.status == 'success') {
            self.favorite = res.data.favorite
          } else {
            this.removeLogin()
          }
        }).catch(() => {
          this.removeLogin()
        })
      },
      fileDownload(no) {
        //拡張子でconfirm表示
        var extFlg = 0;
        for (var i = 0; this.proposal.file_name.length > i; i++) {
          var obj = this.proposal.file_name[i]
          if ((no && obj.no == no && obj.ext.match(/xls|ppt|doc|ai/i)) || (this.chk_files.indexOf(obj.no) != -1 && obj.ext.match(/xls|ppt|doc|ai/i))) {
            extFlg = 1
            break
          }
        }
        if (extFlg) {
          this.$confirm({
            title: " 取り扱い注意！",
            message: "会社PC以外への持ち出し禁止。\n企画書の流用をする際は、実施可否や価格等、必ず都度調整をすること。",
            button: {
              yes: 'OK'
            },
            /**
             * Callback Function
             * @param {Boolean} confirm 
             */
            callback: confirm => {
              if (confirm) {
                this.fileDownloadChild(no)
                return
              }
            }
          })
        } else {
          this.fileDownloadChild(no)
        }
      },
      fileDownloadChild(no) {
        var loader = this.loadingShow()
        let chk
        if (no) {
          chk = no
        } else {
          chk = this.chk_files.join(',')
        }
        if (!chk) {
          alert('選択されてません')
          return
        }
        let params = new URLSearchParams()
        params.append('c', 'proposal-dl')
        params.append('pk', this.$route.params.pk)
        params.append('lo_pk', this.$cookies.get('lo_pk'))
        params.append('lo_sid', this.$cookies.get('lo_sid'))
        params.append('chk', chk)
        return this.axios.post(this.RequestURI, params, {
          responseType: 'arraybuffer',
          headers: {
            "Cache-Control": "no-cache"
          }
        }).then((res) => {
          if (res.data.byteLength) {
            const blob = new Blob([res.data], {
              type: res.headers["content-type"]
            });
            const url = (window.URL || window.webkitURL).createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = this.getFileName(res.headers["content-disposition"]); // ファイル名
            // aタグ要素を画面に一時的に追加する
            document.body.appendChild(a);
            a.click();
            // 不要になったら削除
            document.body.removeChild(a);
            loader.hide()
          } else {
            this.removeLogin()
          }
        }).catch(() => {
          this.removeLogin()
        })
      },
      getFileName(contentDisposition) {
        let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2, contentDisposition.length);
        //デコードするとスペースが"+"になるのでスペースへ置換します
        fileName = decodeURI(fileName).replace(/\+/g, " ");
        return fileName;
      }
    }
  }

</script>
